import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { Users, Heart, TreeDeciduous, GitMerge, Network, History, UserPlus, Orbit } from 'lucide-react';
const SYSTEMIC_ICONS = [Users, Heart, TreeDeciduous, GitMerge, Network, History, UserPlus, Orbit];
export function ReikiBackground() {
  const icons = useMemo(() => {
    return Array.from({
      length: 15
    }).map((_, i) => ({
      id: i,
      Icon: SYSTEMIC_ICONS[i % SYSTEMIC_ICONS.length],
      left: `${Math.random() * 100}%`,
      size: Math.random() * 30 + 15,
      duration: Math.random() * 25 + 25,
      delay: Math.random() * 20,
      opacity: Math.random() * 0.04 + 0.02
    }));
  }, []);
  return <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" data-id="element-240">
      {icons.map(({
      id,
      Icon,
      left,
      size,
      duration,
      delay,
      opacity
    }) => <motion.div key={id} style={{
      position: 'absolute',
      left,
      width: size,
      height: size,
      color: '#1e40af',
      opacity
    }} initial={{
      y: '110vh',
      rotate: 0
    }} animate={{
      y: '-10vh',
      rotate: 360
    }} transition={{
      duration,
      repeat: Infinity,
      delay,
      ease: 'linear'
    }} data-id="element-241">
          <Icon size={size} strokeWidth={1} data-id="element-242" />
        </motion.div>)}
    </div>;
}